import styled, { css } from "styled-components";

type props = {
  selectedColumn: number | null;
  selectedLine: number | null;
  columnNumber: number | null;
  lineNumber: number | null;
  top?: boolean;
  side?: boolean;
  isMatrix?: boolean;
  isHeader?: boolean;
};
export const PicksSelectorCellContainer = styled.div`
  ${(props: props) =>
    props.isHeader &&
    css`
      display: flex;
      flex-direction: column;
      align-items: center;
    `}

  ${(props: props) =>
    props.isMatrix &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}

  background: ${(props: props) =>
    (props.selectedColumn === props.columnNumber &&
      props.columnNumber !== null) ||
    (props.selectedLine === props.lineNumber && props.lineNumber !== null)
      ? `var(--fd-colors-background-hover)`
      : ""};
  width: 100%;
  height: 100%;
  ${(props: {
    selectedColumn: number | null;
    selectedLine: number | null;
    columnNumber: number | null;
    lineNumber: number | null;
    top?: boolean;
    side?: boolean;
  }) =>
    props.top &&
    css`
      box-shadow: inset 0 -1px 0 var(--fd-colors-border-default);
      border-top: 4px solid transparent;
    `}

  ${(props: props) =>
    props.side &&
    ((props.selectedColumn === props.columnNumber &&
      props.columnNumber !== null) ||
      (props.selectedLine === props.lineNumber && props.lineNumber !== null)) &&
    css`
      border-left: 4px solid var(--fd-colors-border-active);
      border-right: 4px solid transparent;
    `}

  ${(props: props) =>
    props.top &&
    ((props.selectedColumn === props.columnNumber &&
      props.columnNumber !== null) ||
      (props.selectedLine === props.lineNumber && props.lineNumber !== null)) &&
    css`
      border-top: 4px solid var(--fd-colors-border-active);
    `}
`;
